import { render, staticRenderFns } from "./UserRoleTableTemplate.vue?vue&type=template&id=bbcc2248"
import script from "./UserRoleTableTemplate.vue?vue&type=script&lang=js"
export * from "./UserRoleTableTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports